import type { ID } from '@octopus-do/octopus-project-core'
import { Grid as GridIcon } from '@octopus-do/octopus-storybook/icons'
import type { WorkspaceItem } from '@store/reducers/dashboard/types'
import { countOwnActiveProjects } from '@store/reducers/dashboard/utils'
import type React from 'react'

import { PROJECTS_COUNT_CLASS_NAME } from '../../Folders'
import { FolderContainer } from '../FolderContainer'
import { FolderLink } from '../FolderLink'

interface Props {
  folder: WorkspaceItem
  workspaceId: ID
  activeFolder: string | null
}

export const DashboardFolder: React.FC<Props> = ({
  workspaceId,
  folder,
  activeFolder,
}) => {
  const { title, id } = folder

  const active = activeFolder === id
  const count = countOwnActiveProjects(folder)

  return (
    <FolderContainer active={active}>
      <FolderLink
        activeFolder={activeFolder}
        workspace={{ id: workspaceId }}
        folderId={id}
        title={title}
      >
        <GridIcon />
      </FolderLink>

      {!!count && <div className={PROJECTS_COUNT_CLASS_NAME}>{count}</div>}
    </FolderContainer>
  )
}
